import React from "react";
import './Progressbar.css'; 


export const Progressbar= ({ step, totalSteps }) => {
  const progressPercent = (step / totalSteps) * 100;

  return (
    <div className="progress-bar-container">
      <div
        className="progress-bar-fill"
        style={{ width: `${progressPercent}%` }}
      ></div>
    </div>
  );
}


